import http from "../../services/http";
const path = "api/section";

const show = ({ onSuccess, onError, onEnd, id = "" }) => {
  return async (dispatch, getState) => {
    try {
      const res = await http.get({
        url: path + `/detail/${id}`,
        headers: {},
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export { show };
